import InspectionPage from 'pages/inspection-page/main';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

export interface RouterProps {
	isShowMenu?: boolean; //是否显示菜单，默认显示
	path: string | string[]; //路由路径，可以是字符串或者数组
	component: React.FC<RouteComponentProps<{}>> | React.ComponentClass<{}>; //路由组件，可以是组件或者组件的实例
	exact?: boolean; //是否严格匹配，默认为true
	isShowFooter?: boolean; //是否显示底部，默认显示
	isShowHeader?: boolean; //是否显示头部，默认显示
	isShow?: boolean; //是否显示页面，默认显示，如果为false，则跳转到首页
	title?: string; // 标题
}

// 检查期间所有访问路径统一展示品牌简介页。
export const routerConfig: RouterProps[] = [
	{
		path: '/',
		exact: false,
		component: InspectionPage,
		isShowHeader: false,
		isShowFooter: false,
		isShowMenu: false,
	},
];
